<template>
  <div class="table-bulk-actions col-lg-4 d-flex">
    <div class="form col-lg-5">
      <label class="control-label">{{$t("common.bulk_actions")}}</label>
      <b-form-select
          v-model="selectedOption"
          class="form-control"
          @change="onChange"
          :options="options"></b-form-select>
    </div>
    <button class="btn btn-outline-primary col-lg-4 apply-btn" @click="apply">{{$t("common.apply")}}</button>

    <parcel-culture-change-dialog :show="showParcelCultureChangeDialog" @close="showParcelCultureChangeDialog = false"
                            :data="parcelCultureChangeDialogData"
                            @onParcelCultureApplied="onParcelCultureApplied"
    ></parcel-culture-change-dialog>
    <parcel-group-change-dialog :show="showParcelGroupChangeDialog" @close="showParcelGroupChangeDialog = false"
                                  :data="parcelGroupDialogData"
                                  @onParcelGroupApplied="onParcelGroupApplied"
    ></parcel-group-change-dialog>

    <slot/>
  </div>
</template>

<script>
import {PARCEL_CULTURE_CHANGE, PARCEL_GROUP_CHANGE} from "@/helpers/bulkActionItems";
import ParcelCultureChangeDialog from "@/components/AgroGrid/TableComponents/ParcelCultureChangeDialog.vue";
import ParcelGroupChangeDialog from "@/components/AgroGrid/TableComponents/ParcelGroupChangeDialog.vue";
import {mapActions, mapGetters} from "vuex";
import {successMessage} from "@/helpers/common";
import {handleError} from "@/helpers/generalActions";

export default {
  components: {ParcelGroupChangeDialog, ParcelCultureChangeDialog},
  props: ['data'],
  name: 'BulkActions',
  data() {
    return {
      selectedOption: '',
      currentComponent: null,
      components: [],
      showParcelCultureChangeDialog: false,
      parcelCultureChangeDialogData: {},
      showParcelGroupChangeDialog: false,
      parcelGroupDialogData: {},
      items: this.data ?? [],
    }
  },
  computed: {
    ...mapGetters({
        parcelSet: 'works-parcels/parcelSet'
    }),
    //bulk action items
    config() {
      return [
        {
          name: PARCEL_CULTURE_CHANGE,
          title: this.$t('bulk_actions.parcel_culture_change'),
          handler: this.handleParcelCultureChange,
        },
        {
          name: PARCEL_GROUP_CHANGE,
          title: this.$t('bulk_actions.parcel_group_change'),
          handler: this.handleParcelGroupChange,
        },
      ];
    },
    selectedItems() {
      return Object.assign([], this.items).filter((item) => {
        return item.selected
      });
    },
    options() {
      const options = [{ value: '', text: '-' }];
      return [...options, ...this.config.map((item) => {
        return { value: item.name, text: item.title};
      })];
    },
    currentAction() {
      return this.config.find(c => c.name === this.selectedOption);
    }
  },
  methods: {
    ...mapActions({
        changeParcelsCulture: 'works-parcels/changeParcelsCulture',
        changeParcelsGroup: 'works-parcels/changeParcelsGroup'
    }),
    onChange(e) {
      this.$emit('onChange', this.selectedOption);
    },
    apply() {
        if (this.currentAction && this.currentAction.handler instanceof Function) {
          this.currentAction.handler();
        }
    },
    handleParcelCultureChange() {
      this.showParcelCultureChangeDialog = true;
      this.parcelCultureChangeDialogData = {
        items: this.selectedItems,
      };
    },
    handleParcelGroupChange() {
      const items = this.selectedItems.filter((item) => {
        return item.is_group === 0;
      });

      this.showParcelGroupChangeDialog = true;
      this.parcelGroupDialogData = {
        items: items,
      };
    },
    onParcelCultureApplied(data) {
      const vm = this;
      this.changeParcelsCulture({
        parcels: data.items.map((parcel) => {
          return {
            uuid: parcel.uuid
          };
        }),
        culture_uuid: data.culture_uuid,
      }).then((resp) => {
        successMessage(vm, resp.message);
        resp.data.parcels.forEach((parcel) => {
          const found = vm.items.find(p => p.uuid === parcel.uuid);
          found.culture_uuid = data.culture_uuid;
          found.culture = data.culture_name;
        })
      }).catch((e) => {
        handleError(vm, e);
      });
    },
    onParcelGroupApplied(data) {
      const vm = this;
      this.changeParcelsGroup({
        parcels: data.items.map((parcel) => {
          return {
            uuid: parcel.uuid
          };
        }),
        parcel_group_uuid: data.group_uuid,
      }).then((resp) => {
        successMessage(vm, resp.message);
        resp.data.parcels.forEach((parcel) => {
          const found = vm.items.find(p => p.uuid === parcel.uuid);
          found.parcel_group_uuid = data.group_uuid;
          found.parcel_group_name = data.group_name;
        })
      }).catch((e) => {
        handleError(vm, e);
      });
    }
  },
  watch: {
    data: {
      handler: function (newVal) {
        this.items = newVal;
      },
      deep: true,
      immediate: true,
    }
  }
}
</script>

<style scoped>
.apply-btn {
    margin-left: 50px;
    margin-top: 32px;
}
</style>
